import { Stack } from '@chakra-ui/react';
import { formatInteger } from '@monetize/utils/core';
import { MButton, MFlex, MText } from '../../../../components/Monetize';
import { pluralize } from '../../../../utils';

interface MassEmailModalFooterProps {
  success?: number;
  failure?: number;
  paymentCollectionFailureCount?: number;
  isLoading: boolean;
  hasSubmitted: boolean;
  onCancel: () => void;
  onSubmit: () => void;
}

export const MassEmailModalFooter = ({
  success,
  failure,
  paymentCollectionFailureCount,
  isLoading,
  hasSubmitted,
  onCancel,
  onSubmit,
}: MassEmailModalFooterProps) => {
  const hasProgress = success !== undefined || failure !== undefined;
  return (
    <MFlex w="100%" alignContent="space-between">
      <Stack gap={1} direction="column">
        {hasProgress && (
          <>
            <MText color="tGreen.approval">
              {formatInteger(success || 0)} enqueued successfully
            </MText>
            <MText color="tRed.base">
              {formatInteger(failure || 0)} {pluralize('error', failure || 0)}
            </MText>
            {!!paymentCollectionFailureCount && (
              <MText color="tRed.base">
                Payment collection failed on{' '}
                {formatInteger(paymentCollectionFailureCount)}{' '}
                {pluralize('invoice', paymentCollectionFailureCount)}
              </MText>
            )}
          </>
        )}
      </Stack>
      <Stack gap={4} direction="row" align="center" justify="right" flex={1}>
        <MButton variant="cancel" minW="auto" onClick={onCancel}>
          Cancel
        </MButton>
        <MButton
          variant="primary"
          minW="auto"
          onClick={onSubmit}
          isDisabled={isLoading || hasSubmitted}
          isLoading={isLoading}
        >
          Send Email
        </MButton>
      </Stack>
    </MFlex>
  );
};
